module.exports = __webpack_public_path__ + "static/media/nemi-banigo.d6f91d32.png";